import React from 'react';
import Header from './Header';
import Footer from './Footer';
import BannerSection from './BannerSection';
import HTMLFlipBook from 'react-pageflip';
import Company_Profile from './assets/Company_Profile.pdf';
import { AiOutlineDownload } from 'react-icons/ai';

const IATACertificate = () => {
  const FlipPage = React.forwardRef(({ src, alt }, ref) => (
    <div ref={ref} className="pdfPage">
      <img src={src} style={{ width: '100%', height: '90%' }} alt={alt} />
    </div>
  ));
  return (
    <>
      <Header />
      <BannerSection pageHeader="IATA CERTIFICATE" />
      <div className="blogContenT">
        <iframe
          src={`${process.env.PUBLIC_URL}/IATA-Certificate.pdf`}
          name="exam_frame"
        ></iframe>
      </div>

      <div style={{ width: '100%', height: '100vh' }}>
        <iframe
          src={`${process.env.PUBLIC_URL}/IATA-Certificate.pdf`}
          width="100%"
          height="100%"
          style={{ border: 'none' }}
          allow="autoplay"
          className="flipBook"
        />
      </div>
      <Footer />
    </>
  );
};

export default IATACertificate;
